"use client";

import { type PropsWithChildren } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface BottomSheetProps extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
}

/* Bottom sheet mobile — animasi enter CSS-only (.anim-sheet / overlay fade;
   keyframes di globals.css). Eks framer-motion AnimatePresence: exit kini
   snap-close tanpa animasi (trade-off disadari, audit 2026-09-24) supaya
   komponen shared ini tidak menyeret framer ke initial bundle landing. */
export const BottomSheet = ({
  open,
  onClose,
  title,
  subtitle,
  children,
}: BottomSheetProps) => {
  return (
    open && (
      <>
        <div className="anim-fade fixed inset-0 z-[60] bg-black/40" onClick={onClose} />
        <div className="anim-sheet bg-card fixed inset-x-0 bottom-0 z-[70] max-h-[85vh] overflow-y-auto rounded-t-2xl">
          <div className="bg-card sticky top-0 z-10 px-5 pt-3 pb-3">
            <div className="bg-muted mx-auto mb-3 h-1 w-10 rounded-full" />
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-foreground text-base font-bold">{title}</h3>
                {subtitle && <p className="text-foreground/40 text-xs">{subtitle}</p>}
              </div>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={onClose}
                className="text-muted-foreground hover:text-foreground"
              >
                <X size={18} />
              </Button>
            </div>
          </div>
          <div className="px-5 pb-8">{children}</div>
        </div>
      </>
    )
  );
};
